// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"217":"7f2f49ec","503":"9c5ae153","650":"692507c2","966":"55ffc863"}[chunkId] + ".chunk.css";
};